import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Logo from './Logo'
import supplierActions from 'store/models/supplier'
import { __ENV__ } from 'awsApi'
import { Timer } from './Timer'
import { parseTime } from 'helpers'
import './styles.scss'
import { logout } from 'helpers/smartUtils'

const getExpiredTime = async () => {
    console.warn('🚀 ~> getExpiredTime start')

    try {
        // Get exired time
        const cognitoUser = await JSON.parse(localStorage.getItem('cognitoUser'))
        if (!cognitoUser) {
            console.warn('🚀 ~> cognitoUser', cognitoUser)
            throw new Error(`Can't parse cognitoUser \n(${cognitoUser.toString()})`)
        }

        const willExpire = await JSON.parse(localStorage.getItem('willExpire'))

        // Get today's time
        const nowTime = new Date().getTime()

        const { hh, mm, ss } = parseTime(willExpire - nowTime)

        if (!hh && !mm && !ss) {
            throw new Error(`Issue is in calculation time`)
        }
        console.warn('🚀 ~>getExpiredTime end', { hh, mm, ss })
        return { hh, mm, ss }
    } catch (error) {
        console.warn('🚀 ~> error', error)
        alert(`${error} in Timer. \nPlease send screenshot to dev team.`)
        return { hh: 0, mm: 20, ss: 0 }
    }
}

function Toolbar() {
    const dispatch = useDispatch()
    const [{ mm, ss }, setTime] = useState({})

    useEffect(() => {
        ;(async () => setTime(await getExpiredTime()))()
    }, [])

    const reset = () => {
        const supplier = JSON.parse(localStorage.getItem('supplier'))
        if (supplier) {
            const { primaryContactEmail } = supplier
            if (primaryContactEmail === 'test-supplier-web2@betterspace.uk' || primaryContactEmail === 'test-supplier-web-ci2@betterspace.uk') {
                dispatch(supplierActions.resetProfileForTests(logout))
            } else {
                logout()
            }
        } else {
            logout()
        }
    }

    return (
        <div className="toolbar">
            <Logo />

            <div style={{ flex: 1 }} />

            <Timer initialMinute={mm} initialSeconds={ss} reset={reset} />
            <button
                type="button"
                className="headerButton underline"
                onClick={() => {
                    __ENV__ === 'DEV' ? reset() : logout()
                }}
            >
                Logout
            </button>
        </div>
    )
}

export default Toolbar
